import React, { FC, useEffect, useState } from "react";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { bookingType } from "data/types";
import toast from "react-hot-toast";
import { fetchData } from "data/api/fetch";
import useAuth from "components/Authprovider/Auth";
import { useParams } from "react-router-dom";

export interface AccountPageProps {
  className?: string;
}

type typeParams = {
  id: any;
};

const BookingsPage: FC<AccountPageProps> = ({ className = "" }) => {

  const {user,token} = useAuth()

  const [bookings,setBookings] = useState<bookingType[]>([])

  const headers = {
    "Accept": "application/json",
    "Authorization": `Bearer ${token}`,
  };
  const { id } = useParams<typeParams>();

  
  
  useEffect(()=>{
    
    const getBookings = fetchData('https://phplaravel-930928-3230982.cloudwaysapps.com/api/user/'+user?.id+'/bookings',{},headers)

    toast.promise(getBookings, {
      loading: "Loading bookings....",
      success: (data: any) => `Successful`,
      error: (error) => `Unable to retrieve bookings`,
    });

    getBookings.then((data: any) => {
      // Use setData to update the state with the data
      setBookings(data.bookings)
      console.log(data)
    });
    
  },[])


  return (
    <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
      <Helmet>
        <title>Account</title>
      </Helmet>
      <CommonLayout>
        <SectionGridFilterCard data={bookings} className="pb-24 lg:pb-28" />
      </CommonLayout>
    </div>
  );
};

export default BookingsPage;
